import React, { useCallback, useEffect, useState } from "react";
import Table from "../../components/Table/Table";
import styles from "assets/jss/material-dashboard-pro-react/components/tableStyle";
import withStyles from "@material-ui/core/styles/withStyles";
import MarketSelector from "../../components/CustomDropdown/MarketSelector";
import { addUserPermission, removeUserPermission, patchUser, getUsers } from "../../api";
import _ from "lodash";
import Overlay from "../../components/Overlay/Overlay";
import NewUserModal from "./NewUserModal";
import RegularButton from "../../components/CustomButtons/Button";
import moment from "moment";
import classNames from "classnames";
import { BsThreeDots } from "react-icons/all";
import Popper from "@material-ui/core/Popper";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";

const useStyles = makeStyles(styles);

function OpenContext({ account, updateRow, currentUser }) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [warning, setWarning] = React.useState(null);

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClickMenuItem = (e, fxn) => {
    e.stopPropagation();
    e.preventDefault();
    switch (fxn) {
      case "toggle_disable":
        if (account.disabled) {
          if(currentUser.type !== "saucey_admin"){
            setWarning({type:"how_to_reenable", cb:() => {}, noCancel:true })
          }else{
            setLoading(true);
            patchUser(account._id, {op: "enable"}).then( () => {
              account.disabled = !account.disabled;
              updateRow(account, () => {
                setLoading(false);
                handleClose()
              });
            }).catch( () => {
              setLoading(false);
            })
          }
        } else {
          setWarning({
            type: "disable",
            cb: () => {
              setLoading(true);
              patchUser(account._id, {op: "disable"}).then( () => {
                account.disabled = !account.disabled;
                updateRow(account, () => {
                  setLoading(false);
                  handleClose()
                });
              }).catch( () => {
                setLoading(false);
              })
            },
          });
        }

        break;
      case "toggle_account_type":
        if (account.type === "user") {
          setWarning({
            type: "promote",
            cb: () => {
              setLoading(true);
              patchUser(account._id, {op: "promote"}).then( () => {
                account.type = "saucey_admin";
                updateRow(account, () => {
                  setLoading(false);
                  handleClose();
                });
              }).catch( () => {
                setLoading(false);
              })
            },
          });
        } else {
          setWarning({
            type: "demote",
            cb: () => {
              setLoading(true);
              patchUser(account._id, {op: "demote"}).then( () => {
                account.type = "user";
                updateRow(account, () => {
                  setLoading(false);
                  handleClose();
                });
              }).catch( () => {
                setLoading(false);
              })
            },
          });        
        }
        break;
      case "resend_invitation":
        setLoading(true);
        patchUser(account._id, {op: "resend_invitation"}).then( () => {
          setLoading(false)
          setWarning({type:"invitation_resent", cb: () => {}, noCancel: true})
        }).catch( () => {
          setLoading(false);
        })
        break;
      default:
    }
  };

  const warningDialog = () => {
    let content;
    let title = "Are you sure?";
    switch (warning.type) {
      case "how_to_reenable":
        title = null;
        content = `Assign at least one permission to ${account.first_name} ${account.last_name} to re-enable their account`;
        break;
      case "invitation_resent":
        title = null;
        content = `Email has been re-sent to ${account.first_name} ${account.last_name}`;
        break;
      case "disable":
        content = `Are you sure you want to disable ${account.first_name} ${account.last_name}'s account?`;
        break;
      case "demote":
        content = `Are you sure you want to change ${account.first_name} ${account.last_name}'s account to a regular user account?`;
        break;
      case "promote":
        content = `Are you sure you want to change ${account.first_name} ${account.last_name}'s account to global admin account?  All fine-grain permissions for this user will be removed.`;
        break;
    }
    return (
      <Dialog open={true} maxWidth="md" fullWidth>
        {title && <DialogTitle>{title}</DialogTitle>}
        <DialogContent>{content}</DialogContent>
        <DialogActions>
          {!warning.noCancel && <RegularButton
            color="info"
            onClick={() => {
              setWarning(null);
            }}
          >
            Cancel
          </RegularButton>}
          <RegularButton
            color="primary"
            onClick={() => {
              setWarning(null);
              warning.cb();
            }}
          >
            Continue
          </RegularButton>
        </DialogActions>
      </Dialog>
    );
  };
  const dropdownItem = classNames(classes.dropdownItem, classes.primaryHover);
  return (
    <div>
      {warning && warningDialog()}
      <RegularButton
        disableRipple
        justIcon
        aria-controls="simple-menu"
        color="transparent"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <BsThreeDots />
      </RegularButton>
      <Popper
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        transition
        disablePortal
        placement="bottom"
        className={classNames({
          [classes.popperClose]: !anchorEl,
          [classes.popperResponsive]: true,
          [classes.popperNav]: true,
        })}
      >
        {({ TransitionProps }) => (
          <Grow
            {...TransitionProps}
            id="profile-menu-list"
            style={{ transformOrigin: "0 0 0" }}
          >
            <Paper className={classes.dropdown}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList role="menu">
                  <MenuItem
                    onClick={(e) => handleClickMenuItem(e, "toggle_disable")}
                    className={dropdownItem}
                  >
                    {account.disabled ? "Re-activate" : "Disable"}
                  </MenuItem>
                  {account.invitation_expire &&
                    moment(account.invitation_expire).isBefore(moment()) && (
                      <MenuItem
                        onClick={(e) =>
                          handleClickMenuItem(e, "resend_invitation")
                        }
                        className={dropdownItem}
                      >
                        Resend Invitation
                      </MenuItem>
                    )}
                  {currentUser.type === "saucey_admin" && (
                    <MenuItem
                      onClick={(e) =>
                        handleClickMenuItem(e, "toggle_account_type")
                      }
                      className={dropdownItem}
                    >
                      {account.type === "saucey_admin"
                        ? "Demote to regular user"
                        : "Convert to global admin"}
                    </MenuItem>
                  )}
                </MenuList>
              </ClickAwayListener>
              {loading && (
                <Overlay
                  type={"loading"}
                  rootClasses={classes.overlayRoot}
                  containerClasses={classes.overlayContainer}
                />
              )}
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
}
class UserTable extends React.Component {
  state = {
    accounts: [],
    loading: true,
    newUserModal: false,
  };

  _getUser = () => {
    this.setState({ loading: true }, () => {
      getUsers().then((res) => {
        let tempAccounts = [];
        if (res.data && res.data.accounts) {
          for (let i = 0; i < res.data.accounts.length; i++) {
            let account = res.data.accounts[i];
            let stock = [];
            let pricing = [];
            let deals = [];
            let user_management = [];
            (account.permissions || []).forEach((permission) => {
              if (this.props.user.type !== "saucey_admin" && !this.props.manageableSellers.includes(permission.seller)){
                return;
              }
              if (permission.permissions.includes("*")) {
                user_management.push(permission.seller);
                deals.push(permission.seller);
                pricing.push(permission.seller);
                stock.push(permission.seller);
                return;
              }
              if (permission.permissions.includes("user_management")) {
                user_management.push(permission.seller);
              }
              if (permission.permissions.includes("pricing")) {
                pricing.push(permission.seller);
              }
              if (permission.permissions.includes("deals")) {
                deals.push(permission.seller);
              }
              if (permission.permissions.includes("stock")) {
                stock.push(permission.seller);
                console.log("PUSHED")
              }
            });
            account.stock = stock;
            account.pricing = pricing;
            account.deals = deals;
            account.user_management = user_management;
            tempAccounts.push(account);
          }
          this.setState({ accounts: tempAccounts, loading: false });
        }
      });
    });
  };
  componentDidMount() {
    this._getUser();
  }
  permissionChanged = (field, e, idx) => {
    let { accounts } = this.state;
    const existing = accounts[idx][field];
    let newVal = e.target.value;

    if (newVal.length === existing.length) {
      return;
    }

    if (newVal.length > existing.length) {
      for (let j = 0; j < newVal.length; j++) {
        if (!existing.includes(newVal[j])) {
          this.setState({ loading: true }, () => {
            addUserPermission(accounts[idx]._id, newVal[j], field)
              .then(() => {
                accounts[idx][field].push(newVal[j]);
                this.setState({ accounts, loading: false });
              })
              .catch(() => {
                this.setState({ loading: false });
              });
          });

          return;
        }
      }
    }
    if (existing.length > newVal.length) {
      for (let j = 0; j < existing.length; j++) {
        if (!newVal.includes(existing[j])) {
          this.setState({ loading: true }, () => {
            removeUserPermission(accounts[idx]._id, existing[j], field).then(
              () => {
                _.remove(accounts[idx][field], (x) => x === existing[j]);
                this.setState({ accounts, loading: false });
              }
            );
          });
          return;
        }
      }
    }
  };

  render() {
    const { accounts, loading, newUserModal } = this.state;
    if (!accounts || !accounts.length) {
      return null;
    }
    return (
      <>
        {loading && <Overlay type="loading" />}
        {newUserModal && (
          <NewUserModal
            closeNewUserModal={(reload) => {
              this.setState({ newUserModal: false });
              if (reload === true) {
                this._getUser();
              }
            }}
          />
        )}
        <RegularButton
          color="primary"
          onClick={() => {
            this.setState({ newUserModal: true });
          }}
        >
          Add New User
        </RegularButton>
        <Table
          striped
          tableHead={[
            "Name",
            // 'Orders',
            "Stock",
            "Pricing",
            "Deals",
            "User Management",
            "Status",
            "",
          ]}
          hits={accounts}
          tableData={accounts.map((account, idx) => {
            let status = account.disabled ? (
              <span style={{ color: "gray" }}>Disabled</span>
            ) : (
              <span style={{ color: "green" }}>Active</span>
            );
            if(account.stock.length === 0
              && account.deals.length === 0
              && account.pricing.length === 0
              && account.user_management.length === 0
              && account.type !== "saucey_admin"){
              account.disabled = true;
              status =  <span style={{ color: "gray" }}>Disabled</span>
            }
            if (account.invitation_expire && !account.password) {
              if (moment(account.invitation_expire).isBefore(moment())) {
                status = (
                  <span style={{ color: "red" }}>Invitation Expired</span>
                );
              } else {
                status = <span style={{ color: "orange" }}>Invited</span>;
              }
            }

            if (account.type === "saucey_admin") {
              return [
                <div className="name">
                  <p>
                    {account.first_name} {account.last_name}
                  </p>
                  <p>{account.email}</p>
                </div>,
                { colSpan: 4, data: "Global Admin" },
                status,
                <OpenContext
                  currentUser={this.props.user}
                  account={account}
                  updateRow={(newInfo, cb) => {
                    accounts[idx] = newInfo;
                    this.setState({ accounts }, cb);
                  }}
                />,
              ];
            } else {
              return [
                <div className="name">
                  <p>
                    {account.first_name} {account.last_name}
                  </p>
                  <p>{account.email}</p>
                </div>,
                <MarketSelector
                  multiple={true}
                  onChange={(e) => this.permissionChanged("stock", e, idx)}
                  onlyShowStoreID
                  useFullID
                  value={account.stock}
                />,
                <MarketSelector
                  multiple={true}
                  onChange={(e) => this.permissionChanged("pricing", e, idx)}
                  onlyShowStoreID
                  useFullID
                  value={account.pricing}
                />,
                <MarketSelector
                  multiple={true}
                  onChange={(e) => this.permissionChanged("deals", e, idx)}
                  onlyShowStoreID
                  useFullID
                  value={account.deals}
                />,
                <MarketSelector
                  multiple={true}
                  onChange={(e) =>
                    this.permissionChanged("user_management", e, idx)
                  }
                  onlyShowStoreID
                  useFullID
                  value={account.user_management}
                />,
                status,
                <OpenContext
                  currentUser={this.props.user}
                  account={account}
                  updateRow={(newInfo, cb) => {
                    accounts[idx] = newInfo;
                    this.setState({ accounts }, cb);
                  }}
                />,
              ];
            }
          })}
        />
      </>
    );
  }
}

export default connect((state) => ({ user: state.app.user, manageableSellers: state.app.manageableSellers }))(
  withStyles(styles)(UserTable)
);
